
<div *ngIf="noSplugsCofiguredObs | async">
  <p class="warn-text">      {{'ss-process-wizard.actor-no-splugs' | translate}}</p>
  
  <button  
    mat-raised-button 
    color="primary" 
    (click)="configureSplugs()"
  >
    <mat-icon>settings</mat-icon>
    {{'ss-process-wizard.configure-splugs' | translate}}
  </button>

</div>


<mat-checkbox 
  color="primary" 
  *ngFor="let splugSignature of signatureTypeDataSourceObs | async"
  (change)="splugChecked($event, splugSignature)" 
  [checked]="(allowedSignatureTypesSubject | async)?.includes(splugSignature.id)"
>
  {{ splugSignature.title }}
</mat-checkbox>
